import moment from 'moment';

const formatTime = time => {
  return moment(time).format('DD/MM/YYYY');
};

export default formatTime;
